import type { TableActionSpec } from '@/@vxapp/@Types/ServiceMetadata'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { QuoteField } from '@/@vxapp/@Enums/PHP/ServicesV2/Quotes/DataProviders/QuoteField'

export const QuotesTableActions = [
  {
    id: 'set-inactive',
    title: PageMeta.Quotes.SetInactive.Title,
    tooltip: PageMeta.Quotes.SetInactive.Tooltip ?? undefined,
    icon: PageMeta.Quotes.SetInactive.Icon,
    color: 'secondary',
    disabled: false,
    hidden: false,
    emit: 'set-inactive',
  },
  {
    id: 'preview',
    title: PageMeta.Quotes.Preview.Title,
    icon: PageMeta.Quotes.Preview.Icon,
    color: 'primary',
    disabled: false,
    hidden: false,
    route: {
      name: PageMeta.Quotes.Preview.Name || '',
      paramKey: 'guid',
      itemKey: QuoteField.DB_IDENTIFIER,
    },
    emit: 'preview',
  },
  {
    id: 'edit',
    title: PageMeta.Quotes.Edit.Title,
    icon: PageMeta.Quotes.Edit.Icon,
    color: 'primary',
    disabled: false,
    hidden: false,
    route: {
      name: PageMeta.Quotes.Edit.Name || '',
      paramKey: 'guid',
      itemKey: QuoteField.DB_IDENTIFIER,
    },
    emit: 'edit',
  },
  {
    id: 'service',
    title: PageMeta.Quotes.Service.Title,
    tooltip: PageMeta.Quotes.Service.Tooltip ?? undefined,
    icon: PageMeta.Quotes.Service.Icon,
    color: 'success',
    disabled: false,
    hidden: false,
    route: {
      name: PageMeta.Quotes.Service.Name || '',
      paramKey: 'guid',
      itemKey: QuoteField.DB_IDENTIFIER,
    },
    emit: 'service',
  },
] as const satisfies readonly TableActionSpec[]
